import axios from '@/axios'

const state = {
  collectionSingle: undefined,
  error: undefined,
  loading: false,
  users: []
};
const actions = {
  async save({commit}, payload) {
    try {
      commit('LOADING', true);
      if (payload.id) {
        await axios({
          method: 'put',
          url: `admin/attribute/${payload.id}`,
          data: payload
        })
      } else {
       const {data} = await axios({
          method: 'post',
          url: 'admin/attribute',
          data: {data:payload}
        })
        return data
      }
    } catch (e) {
      console.log('error has')
      commit('ERROR', e);
      throw e
    } finally {
      commit('LOADING', false);
    }
  },

  async variantId({commit}, id) {
    try {
      commit('LOADING', true);
      let res = await axios.get('admin/attribute/' + id);
      console.log(res.data, 'res-attr')
      commit('VARIANT_ID', res.data);
    } catch (e) {
      commit('ERROR', e);
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },


};
const mutations = {
  UPDATE_VARIANT(state, payload) {
    state.variantEdit = state.variantEdit.map(variant => {
      if (variant.id === payload.id) {
        return Object.assign({}, variant, payload.data)
      }
      return variant
    })
    console.log(state.variant, 'users data kole')
  },

  LOADING(state, payload) {
    state.loading = payload;
  },
  VARIANT_ID(state, payload) {
    state.collectionSingle = payload;
  },
  DELETE_ROW(state, payload) {
    state.collectionSingle.values.splice(payload,1)
  },
  SET_ROW_SOUND(state,payload){
    if (!payload.id) {
      state.collectionSingle.values.push(payload.title);
    } else {
      const ind = state.collectionSingle.values.indexOf(state.collectionSingle.values.find((item) => item.id == payload.id));
      if (ind > -1) {
        state.collectionSingle.values[ind] = Object.assign({}, payload)
      }
    }
  },


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
